'use client'

import * as ToolbarPrimitive from '@radix-ui/react-toolbar'
import * as React from 'react'
import { cn } from '#app/shared/lib/misc.js'

const ToolbarRoot = React.forwardRef<
	React.ElementRef<typeof ToolbarPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof ToolbarPrimitive.Root>
>(({ className, ...props }, ref) => (
	<ToolbarPrimitive.Root
		ref={ref}
		className={cn(
			`
     flex w-full min-w-max justify-between gap-0.5 rounded-lg rounded-b-none
     border border-b-0 border-border px-2 py-1
   `,
			className,
		)}
		{...props}
	/>
))
ToolbarRoot.displayName = ToolbarPrimitive.Root.displayName

const ToolbarToggleGroup = React.forwardRef<
	React.ElementRef<typeof ToolbarPrimitive.ToggleGroup>,
	React.ComponentPropsWithoutRef<typeof ToolbarPrimitive.ToggleGroup>
>(({ className, ...props }, ref) => (
	<ToolbarPrimitive.ToggleGroup
		ref={ref}
		className={cn('flex gap-0.5', className)}
		{...props}
	/>
))
ToolbarToggleGroup.displayName = ToolbarPrimitive.ToggleGroup.displayName

const ToolbarToggleItem = React.forwardRef<
	React.ElementRef<typeof ToolbarPrimitive.ToggleItem>,
	React.ComponentPropsWithoutRef<typeof ToolbarPrimitive.ToggleItem>
>(({ className, ...props }, ref) => (
	<ToolbarPrimitive.ToggleItem
		ref={ref}
		className={cn(
			`
     h-[28px] min-w-[28px] rounded-lg

     data-[state=on]:bg-toolbar-item-active

     hover:bg-toolbar-item-hover
   `,
			className,
		)}
		{...props}
	/>
))
ToolbarToggleItem.displayName = ToolbarPrimitive.ToggleItem.displayName

const ToolbarButton = React.forwardRef<
	React.ElementRef<typeof ToolbarPrimitive.Button>,
	React.ComponentPropsWithoutRef<typeof ToolbarPrimitive.Button>
>(({ className, ...props }, ref) => (
	<ToolbarPrimitive.Button
		ref={ref}
		className={cn(
			`
     h-[28px] min-w-[28px] rounded-lg px-1.5

     hover:bg-toolbar-item-hover
   `,
			className,
		)}
		{...props}
	/>
))
ToolbarButton.displayName = ToolbarPrimitive.Button.displayName

const ToolbarSeparator = React.forwardRef<
	React.ElementRef<typeof ToolbarPrimitive.Separator>,
	React.ComponentPropsWithoutRef<typeof ToolbarPrimitive.Separator>
>(({ className, ...props }, ref) => (
	<ToolbarPrimitive.Separator
		ref={ref}
		className={cn('h-[28px] w-[1px] bg-border', className)}
		{...props}
	/>
))
ToolbarSeparator.displayName = ToolbarPrimitive.Separator.displayName

export {
	ToolbarRoot,
	ToolbarToggleGroup,
	ToolbarToggleItem,
	ToolbarButton,
	ToolbarSeparator,
}
